import triggerDownload from "../../../helpers/triggerDownload";

export default id => async (dispatch, getState, { api }) => {
  const response = await api.debtors.getConnectedClientsExport(id);
  triggerDownload(response.download_url);
};
